import { Component, OnInit } from '@angular/core';
import { MessageService } from '../services/message.service';
import { NgIf, NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-message-bar',
  templateUrl: './message-bar.component.html',
  styleUrls: ['./message-bar.component.scss'],
  imports: [NgIf, MatButton, NgFor],
})
export class MessageBarComponent implements OnInit {
  constructor(readonly msgService: MessageService) {}

  ngOnInit(): void {}

  get messages() {
    return this.msgService.messages.map((msg) => msg.text);
  }

  clearMesssages() {
    this.msgService;
  }
}
